import React from "react";
import { ShoppingCart, X, Plus } from "lucide-react";
import CarouselNavigation from "../Common/CarouselNavigation";
import ModalCloseButton from "../Common/ModalCloseButton";

const ItemModal = ({
  item,
  allItems,
  isPick5Filter,
  prices,
  isLoadingPrices,
  isInCart,
  onClose,
  onNext,
  onPrev,
  onAddToCart,
  onRemoveFromCart,
  onCategoryClick,
  getItemQuantity
}) => {
  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("item-modal")) {
      onClose();
    }
  };

  const handleNavigation = (direction) => {
    const currentIndex = allItems.findIndex((i) => i.id === item.id);
    if (direction === "next") {
      const nextIndex = (currentIndex + 1) % allItems.length;
      onNext(allItems[nextIndex]);
    } else {
      const prevIndex = (currentIndex - 1 + allItems.length) % allItems.length;
      onPrev(allItems[prevIndex]);
    }
  };

  const handleAddToCart = () => {
    onAddToCart({
      id: item.id,
      title: isPick5Filter ? `${item.title} Pick 5` : item.title,
      price: prices[item.id] || item.price,
      image: item.images[0],
    });
  };

  const handleRemoveFromCart = () => {
    onRemoveFromCart(item.id);
  };

  const hasPrevious = allItems.length > 1;
  const hasNext = allItems.length > 1;

  const getPrice = () => {
    if (isPick5Filter) return " 5 for $250.00";
    if (isLoadingPrices) return "Loading...";
    return `$${Number(prices[item.id] || item.price || 0).toFixed(2)}`;
  };

  const quantity = getItemQuantity(item.id) || 0;

  return (
    <div className="item-modal" onClick={handleBackdropClick}>
      <div className="modal-content">
        <ModalCloseButton onClick={onClose} />

        <CarouselNavigation
          onPrevious={(e) => {
            e.stopPropagation();
            handleNavigation("prev");
          }}
          onNext={(e) => {
            e.stopPropagation();
            handleNavigation("next");
          }}
          hasPrevious={hasPrevious}
          hasNext={hasNext}
        />

        <div className="modal-banner">
          <img
            src={item.images[0]}
            alt={item.title}
            onError={(e) => (e.target.src = "/img/datlogoA.png")}
          />
          {quantity > 0 ? (
            <div className="modal-cart-controls">
              <button
                className="add-another-btn"
                onClick={handleAddToCart}
                title="Add another"
              >
                <Plus size={20} />
              </button>
              <span className="quantity-badge">{quantity}</span>
              <button
                className="remove-all-btn"
                onClick={handleRemoveFromCart}
                title="Remove all"
              >
                <X size={20} />
              </button>
            </div>
          ) : (
            <button
              className="add-to-cart-btn"
              onClick={handleAddToCart}
            >
              <ShoppingCart size={20} /> Add to Cart -{getPrice()}
            </button>
          )}
        </div>

        <div className="modal-details">
          <h2 className="modal-title">{item.title}</h2>
          <div className="modal-categories">
            {item.category.split(",").map((cat, i) => (
              <span
                key={i}
                className="category-tag"
                onClick={(e) => {
                  e.stopPropagation();
                  onCategoryClick(cat.trim());
                }}
              >
                {cat.trim()}
              </span>
            ))}
          </div>
          <div
            className="modal-description"
            dangerouslySetInnerHTML={{ __html: item.description }}
          />

          <div className="modal-gallery-wrapper">
            <div className="modal-gallery">
              {item.images.slice(1).map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`${item.title} ${index + 1}`}
                  onError={(e) => (e.target.src = "/img/datlogoA.png")}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemModal;
